module.exports = __webpack_public_path__ + "img/Rose.53f13a0c.jpg";